import { Injectable } from '@angular/core';
import * as THREE from 'three';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter';
import { saveAs } from 'file-saver';

export type IModelExportFormats = 'stl';

@Injectable({
  providedIn: 'root',
})
export class ThreeExporterService {
  /**
   * Export the given object as the given format if supported.
   * @param object THREE.Object3D - Object to export.
   * @param format IModelExportFormats - Format to export to.
   * @param filename string - File name without extensions.
   * @returns Blob containing the data
   */
  public export(
    object: THREE.Object3D,
    format: IModelExportFormats,
    filename?: string
  ): void {
    switch (format) {
      case 'stl':
        this.exportSTL(object, filename);
        break;
      default:
        console.warn('Unsupported export format: ' + format);
        break;
    }
  }

  private exportSTL(object: THREE.Object3D, filename: string = 'model'): void {
    // Parse the input and generate the STL encoded output
    const result = new STLExporter().parse(object, { binary: true });
    saveAs(new Blob([result], { type: 'text/plain' }), filename + '.stl');
  }
}
